"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiField = exports.createNewEntityFromApiData = exports.toPlainObject = exports.getApiFields = void 0;
var apiFieldMetadataKey = 'apiFieldMetadata';
function getApiFieldProperties(target, propertyKey) {
    return Reflect.getMetadata(apiFieldMetadataKey, target, propertyKey);
}
function getApiFields(target) {
    var decoratedFields = [];
    for (var key in target) {
        if (getApiFieldProperties(target, key)) {
            decoratedFields.push(key);
        }
    }
    return decoratedFields;
}
exports.getApiFields = getApiFields;
function toPlainObject(target) {
    var output = {};
    // Return target if it isn't a decorated object (i.e. already plain)
    if (getApiFields(target).length === 0) {
        return target;
    }
    for (var key in target) {
        var apiFieldProperties = getApiFieldProperties(target, key);
        var outputPropertyKey = void 0;
        var outputPropertyValue = void 0;
        if (apiFieldProperties) {
            outputPropertyKey = apiFieldProperties.name || key;
            outputPropertyValue = apiFieldProperties.serialiser
                ? apiFieldProperties.serialiser(target[key], target)
                : target[key];
            var shouldSerialise = outputPropertyValue !== undefined &&
                (apiFieldProperties.serialise !== undefined ? apiFieldProperties.serialise : true);
            if (shouldSerialise) {
                output[outputPropertyKey] = outputPropertyValue;
            }
        }
    }
    return output;
}
exports.toPlainObject = toPlainObject;
function createNewEntityFromApiData(entityConstructor, apiResponseData) {
    var _a;
    var newT = new entityConstructor();
    for (var key in newT) {
        var apiFieldProperties = getApiFieldProperties(newT, key);
        var valueToSetKeyTo = void 0;
        if (apiFieldProperties) {
            // If the field is decorated with ApiField(...)
            // If the API Field name is set in the decorate, use that, otherwise just use same key name
            var apiFieldPropertyName = apiFieldProperties.name || key;
            valueToSetKeyTo = (_a = apiResponseData[apiFieldPropertyName]) !== null && _a !== void 0 ? _a : undefined;
            // If the entity has specified a creator, call that now with the repsonse data
            // TODO check that this isn't a major security hole.
            if (apiFieldProperties.creator) {
                valueToSetKeyTo = apiFieldProperties.creator(valueToSetKeyTo);
            }
        }
        else {
            // If the field isn't decorated, just set the data straight up
            valueToSetKeyTo = apiResponseData[key];
        }
        if (valueToSetKeyTo !== undefined) {
            newT[key] = valueToSetKeyTo;
        }
    }
    return newT;
}
exports.createNewEntityFromApiData = createNewEntityFromApiData;
function ApiField(apiFieldData) {
    return Reflect.metadata(apiFieldMetadataKey, __assign({}, apiFieldData));
}
exports.ApiField = ApiField;
//# sourceMappingURL=ApiField.js.map